export class FiltroExpediente {
    nu_expediente: string;
    anio_expediente: string;
}
